export default "__VITE_ASSET__C2lvd4N8__"